var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "prodClassRepUpgradeModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content" },
          [
            _vm._m(0),
            _c("div", { staticClass: "modal-footer deactiveModal-bgcolor" }, [
              _vm._m(1),
              _c(
                "div",
                {
                  staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-blue-button",
                      attrs: { href: "#ConfirmationModal" },
                      on: { click: _vm.upgradeProductClassificationRationale },
                    },
                    [_vm._v("Yes, Upgrade")]
                  ),
                ]
              ),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header deactiveModal-bgcolor" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#prodClassRepUpgradeModal",
          },
        },
        [_vm._v("×")]
      ),
      _c("div", { staticClass: "modal-title" }, [
        _c("div", { staticClass: "title-text" }, [
          _vm._v(
            "Are you sure you want to upgrade this classification rationale report?"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10" },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-block emergo-white-button",
            attrs: {
              "data-toggle": "modal",
              "data-target": "#prodClassRepUpgradeModal",
            },
          },
          [_vm._v("No, Cancel")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }